export default __webpack_public_path__ + "static/media/EuclidCircularA-Medium.88cf6ac9.ttf";